// src/components/one-pager/PdfViewer.tsx

import React from 'react';
import { motion } from 'framer-motion';

interface PdfViewerProps {
  imageUrl: string;
  altText: string;
}

export const PdfViewer: React.FC<PdfViewerProps> = ({ imageUrl, altText }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className="border-2 border-black bg-white p-2 shadow-[8px_8px_0_0_black]"
    >
      <img src={imageUrl} alt={altText} className="w-full h-auto" />
    </motion.div>
  );
};